import { CLAIM_STATUS, RESOLUTION_TYPE } from "../constants";
import type { Claim } from "../types";

export const normalizeResolution = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  return String(value).trim().toLowerCase().replace(/\s+/g, "_");
};

export const isAwaitingReview = (claim: Claim) =>
  claim.claim_status === CLAIM_STATUS.PENDING ||
  claim.claim_status === CLAIM_STATUS.NEW;

export const isClaimComplete = (claim: Claim) =>
  claim.claim_status === CLAIM_STATUS.CLOSED ||
  claim.claim_status === CLAIM_STATUS.DENIED;

export const getEffectiveResolution = (claim: Claim): string => {
  if (claim.claim_resolution) {
    return normalizeResolution(claim.claim_resolution) ?? RESOLUTION_TYPE.DEFAULT;
  }
  if (claim.resolution?.refunds?.length) {
    return RESOLUTION_TYPE.REFUND;
  }
  if (claim.resolution?.store_credits?.length) {
    return RESOLUTION_TYPE.STORE_CREDIT;
  }
  if (claim.resolution?.reships?.length) {
    return RESOLUTION_TYPE.RESHIP;
  }
  return normalizeResolution(claim.preferred_resolution) ?? RESOLUTION_TYPE.DEFAULT;
};

export const buildTimelineMap = (
  timeline: Claim["timeline"] = [],
): Record<string, string> =>
  (timeline ?? []).reduce<Record<string, string>>((map, event) => {
    map[event.key] = event.at;
    return map;
  }, {});

export const getLastUpdatedAt = (claim: Claim): Date | null => {
  const candidates = [
    claim.updated_at,
    claim.closed_at,
    claim.submitted_at,
    claim.created_at,
    ...(claim.timeline ?? []).map((event) => event.at),
  ].filter(Boolean) as string[];

  if (!candidates.length) {
    return null;
  }

  return candidates.reduce((latest, value) => {
    const date = new Date(value);
    return date > latest ? date : latest;
  }, new Date(candidates[0]));
};
